import React from 'react';
import Box from '@mui/material/Box';
import ChipSelect from './ChipSelect';
import DropDownSelect from './DropDownSelect';

type Props = {
  unitTypes: any[],
  invertSelected: any
}

export default class extends React.Component<Props> {
  render() {
    return <Box sx={{paddingTop: '11px', paddingBottom: '41px'}}>
      <Box sx={{ display: {xs: 'none', sm: 'block', md: 'block', lg: 'block'}}}>
        <ChipSelect unitTypes={this.props.unitTypes} invertSelected={this.props.invertSelected}></ChipSelect>
      </Box>
      <Box sx={{ display: {xs: 'block', sm: 'none', md: 'none', lg: 'none'}, marginBottom: '24px', paddingBottom: '24px'}}>
        <DropDownSelect unitTypes={this.props.unitTypes} invertSelected={this.props.invertSelected}></DropDownSelect>
      </Box>
    </Box>;
  }
}